import { ProcessCellForExportParams } from 'ag-grid-community';
import { formatNumber } from 'src/utils/formatNumber';

export const processThousandOperators = (params: ProcessCellForExportParams) => {
    return formatNumber(params.value);
};
